/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './lab-test-category-group.reducer';

export const LabTestCategoryGroupDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const labTestCategoryGroupEntity = useAppSelector(state => state.labTestCategoryGroup.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="labTestCategoryGroupDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.labTestCategoryGroup.detail.title">LabTestCategoryGroup</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.labTestCategoryGroup.id">Id</Translate>
            </span>
          </dt>
          <dd>{labTestCategoryGroupEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.labTestCategoryGroup.active">Active</Translate>
            </span>
          </dt>
          <dd>{labTestCategoryGroupEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.labTestCategoryGroup.description">Description</Translate>
            </span>
          </dt>
          <dd>{labTestCategoryGroupEntity.description}</dd>
          <dt>
            <span id="displayKey">
              <Translate contentKey="tinyMedicRestApp.labTestCategoryGroup.displayKey">Display Key</Translate>
            </span>
          </dt>
          <dd>{labTestCategoryGroupEntity.displayKey}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.labTestCategoryGroup.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{labTestCategoryGroupEntity.lastupdated}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.labTestCategoryGroup.name">Name</Translate>
            </span>
          </dt>
          <dd>{labTestCategoryGroupEntity.name}</dd>
          <dt>
            <span id="sortOrder">
              <Translate contentKey="tinyMedicRestApp.labTestCategoryGroup.sortOrder">Sort Order</Translate>
            </span>
          </dt>
          <dd>{labTestCategoryGroupEntity.sortOrder}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.labTestCategoryGroup.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{labTestCategoryGroupEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.labTestCategoryGroup.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{labTestCategoryGroupEntity.microSec}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.labTestCategoryGroup.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{labTestCategoryGroupEntity.cursor}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.labTestCategoryGroup.hospital">Hospital</Translate>
          </dt>
          <dd>{labTestCategoryGroupEntity.hospital ? labTestCategoryGroupEntity.hospital.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/lab-test-category-group" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/lab-test-category-group/${labTestCategoryGroupEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default LabTestCategoryGroupDetail;
